export default __webpack_public_path__ + "static/media/5b.7e4a6def.png";